module.exports = __webpack_public_path__ + "/images/ico-share-url.cd5e61e.svg";